module.exports = __webpack_public_path__ + "img/PREDIZE_BANNER.a1e6a6cc.png";